export default __webpack_public_path__ + "static/media/multicar8.a54c19ff.jpeg";